import app from '../app';

/**
 * Устанавливаем куку для отслеживания бездействия
 */
app.factory('expiredCookieService', [
  '$rootScope',
  'addFormService',
  '$cookies',
  '$interval',
  'activeDraftService',
  'userService',
  'categoryService',
  ($rootScope, addFormService, $cookies, $interval, activeDraftService, userService, categoryService) => {
    const COOKIE_NAME_PREFIX = 'activeAddForm';
    const COOKIE_DOMAIN = '.cian.ru';

    const autoSaveInterval = 10000;

    let autoSave;
    let isActive;

    const init = () => {
      isActive = true;

      renew();
      autoSave = $interval(renew, autoSaveInterval);
    };

    const renew = () => {
      if (!isActive) {
        return;
      }

      const userId = getUserId();

      if (parseInt(getCookie(), 10) < 0) {
        return;
      }

      const cookieName = COOKIE_NAME_PREFIX + userId;

      // Только для активных черновиков проверяем время жизни брошенной ФП
      activeDraftService.isActiveDraftEnabled().then(enabled => {
        if (enabled && isActive) {
          updateCookie(cookieName);
        } else {
          removeCookie(cookieName);
        }
      });
    };

    const destroy = () => {
      isActive = false;

      if (autoSave) {
        $interval.cancel(autoSave);
      }

      const userId = getUserId();

      removeCookie(COOKIE_NAME_PREFIX + userId);
    };

    const getCookie = () => {
      const userId = getUserId();

      return $cookies.get(COOKIE_NAME_PREFIX + userId);
    };

    const getUserId = () => {
      const userId = userService && userService.user && (userService.user.cianUserId || userService.user.userId);

      return userId || '';
    };

    /**
     * Добавляем текущего пользователя в массив куки.
     * Если пользователь не авторизован, то ничего не делаем
     */
    const updateCookie = cookieName => {
      if (parseInt(getCookie(), 10) < 0) {
        return;
      }

      $cookies.put(cookieName, +new Date(), {
        secure: false,
        path: '/',
        domain: COOKIE_DOMAIN,
      });
    };

    /**
     * Форма заполнена, кука не нужна
     */
    const removeCookie = cookieName => {
      if (parseInt(getCookie(), 10) < 0) {
        return;
      }

      $cookies.remove(cookieName, {
        path: '/',
        domain: COOKIE_DOMAIN,
      });
    };

    /**
     * Как только объявление успешно размещено, больше не наблюдаем
     */
    $rootScope.$watchGroup(
      [
        () => addFormService.ad && addFormService.ad.status,
        () => addFormService.ad && addFormService.ad.id,
        () => addFormService.ad && addFormService.ad.category,
      ],
      ([status, id, category]) => {
        const isPublished = id && status === 'published';
        const { propertyType } = categoryService.getInfoByCategory(category);
        const isCommercial = propertyType === 'commercial';
        const isNewBuild = category === 'newBuildingFlatSale';

        if (isActive && (isPublished || isCommercial || isNewBuild)) {
          destroy();

          return;
        }

        if (!isActive && !isCommercial && !isNewBuild) {
          init();
        }
      },
    );

    return {
      init,
      destroy,
    };
  },
]);
